<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="type">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Compte <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="compte">
            <option value="">Sélectionner un compte</option>
            <option *ngFor="let c of comptes" [value]="c.uuid">{{ c.libelle }} ({{ c.numero }})</option>
          </select>
          <span *ngIf="submit && f.compte.errors?.required" class="text-danger">Le compte est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="montant">
          <span *ngIf="submit && f.montant.errors?.required" class="text-danger">Le montant est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date <span class="text-danger">*</span></label>
          <input type="date" class="form-control" formControlName="date">
          <span *ngIf="submit && f.date.errors?.required" class="text-danger">La date est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Catégorie</label>
          <select class="form-control" formControlName="categorie">
            <option value="">Sélectionner</option>
            <option *ngFor="let c of categories" [value]="c.value">{{ c.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Mode de paiement</label>
          <select class="form-control" formControlName="modePaiement">
            <option *ngFor="let m of modesPaiement" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Référence</label>
          <input type="text" class="form-control" formControlName="reference" placeholder="Référence">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Libellé</label>
          <input type="text" class="form-control" formControlName="libelle" placeholder="Libellé">
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" rows="2"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
